import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useState, useContext } from 'react';
import { useColorScheme, useLocalStorage } from '@hooks';
export const ThemeContext = createContext(null);
export function useTheme() {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('ThemeProvider was not found');
    }
    return [context.theme, context.setTheme];
}
export default function ThemeProvider({ children }) {
    const ls = useLocalStorage({ key: '@omatsuri/theme', delay: 10 });
    const systemTheme = useColorScheme();
    const [userTheme, setUserTheme] = useState(ls.retrieve() || null);
    const handleUserThemeChange = (theme) => {
        ls.save(theme);
        setUserTheme(theme);
    };
    return (_jsx(ThemeContext.Provider, { value: {
            theme: userTheme || systemTheme,
            setTheme: handleUserThemeChange,
        }, children: children }));
}
